module.exports = __webpack_public_path__ + "img/logo-mobile.019af777.png";